"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (pageload) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.pending && appState.pending.isLoading == false && pageload == true) {
            fetch("/v1/pending", {
                method: 'GET'
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_PENDING', model: data });
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_PENDING' });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_PENDING':
            return {
                isLoading: false
            };
        case 'RECEIVE_PENDING':
            return {
                isLoading: true,
                response: action.model
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=Pending.js.map